import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  setDefaultChannel,
  getDefaultChannel,
  getIssues,
  getProject,
  getBotChannel,
  logOutSkillUser,
  // addUserBasicToken,
  deleteUserConfig,
  getSkillUser,
  getJiraBoards,
  deleteDefaultChannel,
  getServiceDeskProject,
  deleteChannelConfigurations,
} from '../../skills_action';
import { connect } from 'react-redux';
import moment from 'moment';

import { withRouter } from 'react-router-dom';
import { SettingOutlined } from '@ant-design/icons';


import {
  Button,
  Select,
  Dropdown,
  Menu,
  Modal,
  Card,
  message,
  Row,
  Col,
  Layout,
  Typography,
  Collapse,
  Switch,
  PageHeader,
  Tabs,
  Popconfirm,
  Alert,
  Anchor,
} from 'antd';
import '../../jira/jira.css';
// import JiraServerModal from "./jira_server_modal";

const { Option } = Select;
const { Text } = Typography;
const PersonalCreationDefault = (props) => {
  const dispatch = useDispatch();

  const projects = useSelector((state) => {
    return props.subSkill === 'jira_software'
      ? state.skills.projects.filter(
        (project) =>
          project.projectTypeKey === 'software' ||
          project.projectTypeKey === 'business'
      )
      : state.skills.jsd_projects;
  });

  const issueTypes = useSelector((state) => {
    return props.subSkill === 'jira_software'
      ? state.skills.issues
      : state.skills.requestTypes;
  });
  const personalChannelDefault = useSelector((state) => {
    return state.skills.personalChannelDefault;
  });

  const [cDefault, setDefaults] = useState({
    defaultProject: '',
    defaultIssue: '',
    board: '',
    create_tickets_by_default: false,
  });
  const [edit, openEditState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [defaultloading, setDefaultLoading] = useState(false);
  const [boardData, setBoards] = useState([]);
  // const props.subSkill=
  useEffect(() => {
    (async () => {
      //  console.log("yes i ran ")
      setLoading(true);
      openEditState(false);
      if (props.subSkill == 'jira_software') {
        dispatch(
          getProject(props.match.params.wId, false, props.sConfigMember)
        ).then((res) => {
          // setState({ jsd_loading: false });
        });
      } else {
        dispatch(
          getServiceDeskProject(
            props.match.params.wId,
            props.match.params.skill_id,
            { saveInJSDProjects: true, user_id: props.sConfigMember }
          )
        );
      }
      // console.log(props.botChanne)
      let res = await dispatch(
        getDefaultChannel(
          props.match.params.wId,
          props.match.params.skill_id,
          props.botChannel,
          'personal'
        )
      );
      setLoading(false);

      if (
        res.data.success &&
        res.data.link_info &&
        res.data.link_info.link_info
      ) {
        let info = res.data.link_info.link_info;
        if (props.subSkill == 'jira_software') {
          if (res.data.link_info) {
            if (info.project_id) {
              setDefaults({
                ...cDefault,
                defaultProject: info.project_id,
                defaultIssue: info.issue_id,
                board: info.board ? info.board.id.toString() : null,
              });

              dispatch(
                getIssues(
                  props.match.params.wId,
                  info.project_id,
                  false,
                  false,
                  false,
                  props.sConfigMember
                )
              );
              let query = 'projectKeyOrId=' + info.project_id;
              /*res.data.link_info.link_info.board&&*/

              let boardData = await dispatch(
                getJiraBoards(props.match.params.wId, query)
              );
              if (
                boardData.data.boards &&
                boardData.data.boards[0] &&
                boardData.data.boards[0].name
              ) {
                // setState({ board: boardData.data.boards[0].name })

                setBoards(boardData.data.boards);
                // setState({ boardData: boardData.data.boards });
              }
            }
          }
        } else {
          if (info.jira_service_desk) {
            // setDefaults({...cDefault,defaultProject:info.jira_service_desk.project_id,defaultIssue:info.jira_service_desk.requestType.name,create_tickets_by_default : info.create_tickets_by_default || false })
            let data = {
              ...cDefault,
              defaultProject: info.jira_service_desk.project_id,
              create_tickets_by_default:
                info.create_tickets_by_default || false,
            };
            if (
              info.jira_service_desk.requestType &&
              info.jira_service_desk.requestType.name
            )
              data.defaultIssue = info.jira_service_desk.requestType.name;
            setDefaults(data);

            dispatch(
              getIssues(
                props.match.params.wId,
                info.jira_service_desk.project_service_desk_id,
                true,
                true,
                false,
                props.sConfigMember
              )
            );
            // .then(res => console.log('here'));
          }
        }
      }
    })();
  }, [props.subSkill, props.botChannel, personalChannelDefault._id]);

  useEffect(() => {
    if (!personalChannelDefault._id) {
      setDefaults({
        defaultProject: '',
        defaultIssue: '',
        board: '',
        create_tickets_by_default: false,
      });
    }
  }, [personalChannelDefault._id]);
  const onChangeProject = async (event, data) => {
    let updateObj = {};
    // console.log(props.subSkill)
    let isJsd = props.subSkill == 'jira_service_desk' ? true : false;
    updateObj.defaultProject = event;
    setDefaults({ ...cDefault, defaultProject: event });
    // setDefaults({...cDefault,defaultProject:event})

    /*console.log("project valueeeeee",selectedProject);*/
    let res = await dispatch(
      getIssues(
        props.match.params.wId,
        isJsd ? data.project.id : event,
        isJsd,
        isJsd
      )
    );
    if (res.data && res.data.success && props.subSkill === 'jira_software')
      updateObj.defaultIssue = res.data.issueTypes[0].value;
    if (!isJsd) {
      let query = 'projectKeyOrId=' + event;
      let boardData = await dispatch(
        getJiraBoards(props.match.params.wId, query)
      );
      if (
        boardData.data.success &&
        boardData.data.boards &&
        boardData.data.boards.length > 0 &&
        boardData.data.boards[0].name
      ) {
        // updateObj.boardData=boardData.data.boards
        setBoards(boardData.data.boards);
        updateObj.board = boardData.data.boards[0].name;
        // setDefaults({...cDefault,boardData:boardData.data.boards,board: boardData.data.boards[0].name})
      } else {
        updateObj.boardData = [];
        updateObj.board = null;

        // setDefaults({...cDefault,boardData: [], board: null})
      }
      // console.log(updateObj)
    } else {
      updateObj.defaultIssue = '';
    }
    setDefaults({ ...cDefault, ...updateObj });
  };

  // onChangeBoard = (event, value) => {
  //   this.setState({ board: value && value.key ? value.key : null });
  // };

  const onCancel = async () => {
    if (personalChannelDefault && personalChannelDefault.link_info) {
      let info = personalChannelDefault.link_info;
      let isJsd = props.subSkill == 'jira_service_desk' ? true : false;
      if (isJsd) {
        if (info.jira_service_desk) {
          // setDefaults({...cDefault,defaultProject:info.jira_service_desk.project_id,defaultIssue:info.jira_service_desk.requestType.name,create_tickets_by_default : info.create_tickets_by_default || false })
          let data = {
            ...cDefault,
            defaultProject: info.jira_service_desk.project_id,
            create_tickets_by_default: info.create_tickets_by_default || false,
          };
          if (
            info.jira_service_desk.requestType &&
            info.jira_service_desk.requestType.name
          )
            data.defaultIssue = info.jira_service_desk.requestType.name;
          setDefaults(data);
        }
      } else {
        if (info.project_id) {
          setDefaults({
            ...cDefault,
            defaultProject: info.project_id,
            defaultIssue: info.issue_id,
            board: info.board ? info.board.id.toString() : null,
          });
        }
      }
    }
    openEditState(false);
  };
  const onClickSave = async () => {
    let error = {};

    let selectedIssueData =
      issueTypes &&
      issueTypes.find((issue) => issue.value == cDefault.defaultIssue);

    let selectedProjectData =
      projects &&
      projects.find(
        (project) =>
          project.id == cDefault.defaultProject ||
          project.projectId == cDefault.defaultProject
      );
    let selectedBoardData =
      cDefault.board && boardData.find((board) => board.id == cDefault.board);
    //  console.log('data',selectedIssueData,selectedProjectData)
    // let data= {link_info: personalChannelDefault.link_info}
    let link_info =
      props.subSkill === 'jira_software'
        ? {
          issue_id: cDefault.defaultIssue,
          project_id: cDefault.defaultProject,
          project_name: selectedProjectData && selectedProjectData.name,
          issueName: selectedIssueData && selectedIssueData.value,
          issueType: cDefault.defaultIssue
            ? { id: selectedIssueData.id, name: selectedIssueData.text }
            : {},
          board: selectedBoardData ? selectedBoardData : null,
        }
        : {
          jira_service_desk: {
            project_id: cDefault.defaultProject,
            project_service_desk_id:
              selectedProjectData && selectedProjectData.id,
            project: selectedProjectData,
            project_name: selectedProjectData
              ? `${selectedProjectData.projectName} (${selectedProjectData.projectKey})`
              : null,
            // requestType: { name: selectedIssueData.value, id: selectedIssueData.id },
          },
        };

    if (props.subSkill === 'jira_service_desk') {
      if (selectedIssueData)
        link_info.jira_service_desk.requestType = {
          name: selectedIssueData.value,
          id: selectedIssueData.id,
        };
    }

    let data = {};

    if (personalChannelDefault && personalChannelDefault.link_info) {
      data.link_info = { ...personalChannelDefault.link_info, ...link_info };
    } else {
      data.link_info = link_info;
    }

    data.channel_id = props.botChannel;
    data.updated_by = localStorage.trooprUserId;
    data.skill_id = props.match.params.skill_id;

    if (
      cDefault.defaultProject &&
      (props.subSkill === 'jira_service_desk'
        ? true
        : cDefault.defaultIssue && link_info.issueType.id) &&
      data.channel_id &&
      localStorage.trooprUserId
    ) {
      setDefaultLoading(true);

      let res = await dispatch(
        setDefaultChannel(
          props.match.params.wId,
          props.match.params.skill_id,
          data,
          'channel'
        )
      );
      if (res.data.success) {
        props.getCommonData(props.botChannel);
        // setDefaults({...cDefault,defaultProject: res.data.link_info.link_info.project_id,
        //   defaultIssue: res.data.link_info.link_info.issue_id})

        openEditState(false);

        // !res.data.link_info.link_info.board && setBoards([]);
        setDefaultLoading(false);
        // setState({ defaultloading: false });
        message.success('Saved successfully');
      } else {
        message.error('Error saving  Creation Defaults');
      }
    } else {
      if (!cDefault.defaultProject) {
        message.error('No Issue project selected');
      } else if (!cDefault.defaultIssue) {
        message.error('No Issue type selected');
      }
      // setState({ error: error });
    }
  };

  // openEditState = async (isJsdConfig) => {
  //   if (isJsdConfig) {
  //     this.setState({ jsd_edit: true });
  //   } else {
  //     this.setState({ edit: true });
  //     if (this.props.personalChannelDefault.link_info) {
  //       if (this.props.personalChannelDefault.link_info.project_id) {
  //         if (this.props.personalChannelDefault.link_info) {
  //           let query = "projectKeyOrId=" + this.props.personalChannelDefault.link_info.project_id;
  //           await this.props.getJiraBoards(this.props.match.params.wId, query).then((boardData) => {
  //             if (boardData && boardData.data && boardData.data.boards && boardData.data.boards.length > 0 && boardData.data.boards[0].name) {
  //               this.setState({ boardData: boardData.data.boards });
  //             } else this.setState({ boardData: [] });
  //           });
  //         }
  //       }
  //     }
  //   }
  // };

  const onClickDelete = async () => {
    setDefaultLoading(true);
    let data = { ...personalChannelDefault };

    if (props.subSkill === 'jira_service_desk') {
      if (personalChannelDefault.link_info.project_id) {
        delete data.link_info.jira_service_desk;
        delete data.link_info.create_tickets_by_default;
      } else {
        deletePersonalDefaults();
        return;
      }
    } else {
      if (personalChannelDefault.link_info.jira_service_desk) {
        data.link_info = {
          jira_service_desk: personalChannelDefault.link_info.jira_service_desk,
          create_tickets_by_default:
            personalChannelDefault.create_tickets_by_default || false,
        };
      } else {
        deletePersonalDefaults();
        return;
      }
    }

    let res = await dispatch(
      setDefaultChannel(
        props.match.params.wId,
        props.match.params.skill_id,
        data,
        'channel'
      )
    );
    if (res.data.success) {
      message.success('Persoanl defaults deleted successfully');
    } else {
      message.error('Error while deleting Persoanl defaults');
    }

    setDefaults({
      defaultProject: '',
      defaultIssue: '',
      board: '',
      create_tickets_by_default: false,
    });
    setDefaultLoading(false);
  };

  const deletePersonalDefaults = async () => {
    let res = await dispatch(
      deleteDefaultChannel(
        props.match.params.wId,
        props.match.params.skill_id,
        props.botChannel,
        'personal'
      )
    );
    if (res.success) {
      message.success('Persoanl defaults deleted successfully');
      props.getCommonData(props.botChannel);
    } else {
      message.error('Error deleting personal defaults');
    }
    setDefaultLoading(false);

    setDefaults({
      defaultProject: '',
      defaultIssue: '',
      board: '',
      create_tickets_by_default: false,
    });
  };
  // console.log(cDefault ,projects)
  return (
    <Card
      id='issue-default'
      bodyStyle={{ width: '100%' }}
      title={
        props.subSkill === 'jira_service_desk'
          ? 'Request creation settings'
          : 'Issue creation settings'
      }
      loading={loading}
    >
      <Text type='secondary'>
        Following defaults will be used during issue creation in private
        conversation with "Troopr Assistant" and in DM channels".
      </Text>
      <div
        style={{
          marginTop: 24,
          marginBottom: 16,
          display: 'flex',
          flexDirection: 'row',
          width: '80%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* <Text type='secondary' strong> */}

          <span>
            <strong>Default Project</strong>
          </span>

          {/* </Text> */}
          <Select
            style={{ width: 200, marginRight: 8 }}
            name='defaultProject'
            value={cDefault.defaultProject}
            onChange={(value, data) => onChangeProject(value, data)}
            showSearch={true}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            disabled={!edit}
          // disabled={true}
          >
            {projects &&
              projects.map((project, index) => {
                return props.subSkill === 'jira_software' ? (
                  <Option key={project.id} value={project.id}>
                    {project.name + ` (${project.key})`}
                  </Option>
                ) : (
                  <Option
                    key={project.projectId}
                    value={project.projectId || project.id}
                    project={project}
                  >
                    {project.projectName + ` (${project.projectKey})`}
                  </Option>
                );
              })}
          </Select>

          {/* {error.defaultProject && <div className='error_message'>{error.defaultProject}</div>} */}
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {/* <Text type='secondary' strong> */}
          <span>
            <strong>
              {props.subSkill === 'jira_service_desk'
                ? 'Default Request type'
                : 'Default Issue type'}
            </strong>
          </span>

          {/* </Text> */}

          <Select
            style={{ width: 200, marginRight: 8 }}
            name='defaultIssue'
            value={cDefault.defaultIssue}
            onChange={(e) => setDefaults({ ...cDefault, defaultIssue: e })}
            showSearch={true}
            allowClear={props.subSkill === 'jira_service_desk' ? true : false}
            // let projectFound = false;
            // if (defaultProject) projectFound = projects.find((project) => project.id == defaultProject)
            disabled={
              edit &&
                projects.find(
                  (project) =>
                    project.id === cDefault.defaultProject ||
                    project.projectId === cDefault.defaultProject
                )
                ? false
                : true
            }
          >
            {/* {console.log("ISSUE TYPE",cDefault.defaultIssue)} */}
            {issueTypes &&
              issueTypes.map((issue, index) => (
                <Option key={issue.value} value={issue.value}>
                  {issue.text}
                </Option>
              ))}
          </Select>
          {/* {error.defaultIssue && <div className='error_message'>{error.defaultIssue}</div>} */}
        </div>

        {
          // <div>
          //   {/* <Text type='secondary' strong className='Jira_preference_personal_default_type'> */}
          //     Board (optional)
          //   {/* </Text> */}
          //   <Select
          //     style={{ width: 200, marginRight: 8 }}
          //     name='boards'
          //     showSearch={true}
          //     value={cDefault.board}
          //     filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          //     defaultValue={cDefault.board}
          //     // disabled={!edit}
          //     disabled={edit && projects.find((project) => project.id == cDefault.defaultProject)? false : true}
          //     onChange={(e)=>setDefaults({...cDefault,board:e})}
          //     allowClear
          //     // disabled={true}
          //   >
          //     {boardData.map((board) => {
          //       return (
          //         <Option value={board.id.toString()} key={board.id.toString()} label={board.name}>
          //           {board.name + ` (${board.type})`}
          //         </Option>
          //       );
          //     })}
          //   </Select>
          // </div>
        }
      </div>
      {((props.subSkill === 'jira_service_desk' &&
        personalChannelDefault.link_info &&
        personalChannelDefault.link_info.jira_service_desk) ||
        (props.subSkill === 'jira_software' &&
          personalChannelDefault.link_info &&
          personalChannelDefault.link_info.project_id &&
          !edit)) && (
          <Button
            // type='danger'
            danger
            style={{ float: 'right', width: '114px' }}
            loading={defaultloading}
            onClick={() => onClickDelete('issue_defaults')}
          >
            Delete
          </Button>
        )}
      {edit ? (
        <div>
          <Button
            /*className=" btn_114 margin__right__button"*/ style={{
              width: '114px',
            }}
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <Button
            type='primary'
            onClick={onClickSave}
            style={{ width: '114px', marginLeft: '10px' }}
          >
            Save
          </Button>
        </div>
      ) : (
        <Button
          /*className=" 114 margin__right__button_edit"*/ style={{
            width: '114px',
          }}
          onClick={() => openEditState(true)}
        >
          Edit
        </Button>
      )}
    </Card>
  );
};

export default withRouter(PersonalCreationDefault);
